import { render, staticRenderFns } from "./ServersCloudflare.vue?vue&type=template&id=6c1c1210"
import script from "./ServersCloudflare.vue?vue&type=script&lang=js"
export * from "./ServersCloudflare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports